@if (showMenu) {
  <div id="multiplePlacemarksMenu" appAdjustMenuPosition [position]="position" class="multiplePlacemarksMenuContainer">
    <perfect-scrollbar class="scrollbar">
      <ul id="menu" class="multiplePlacemarksList">
        @for (placemark of multiplePlacemarks; track placemark; let i = $index) {
          <li class="list-group multiplePlacemarksMenuItem">
            <a (click)="openPlacemark($event,placemark)" #placemarkOption [attr.data-index]="i" (mouseleave)="onMouseLeave($event, placemark)" (contextmenu)="openRightClickMenu($event, placemark)"
              (mouseenter)="onMouseHover($event, placemark)" class="list-group-item" style="white-space: nowrap;">
              <div class="placemarkIconContainer">
                <img class="icon placemarkIcon" alt="" id="placemarkIntersect" [src]="placemark.iconUrl | safe"/>
                @if (placemark.commentIconUrl) {
                  <img class="icon childIcon" alt="Comment Icon" [src]="placemark.commentIconUrl | safe"/>
                }
              </div>
              <div class="multiplePlacemarksMenuItemText" #objectName insTooltip [cfg]="getToolTipConf(objectName, placemark.name)">{{placemark.name}}</div>
            </a>
          </li>
        }
      </ul>
    </perfect-scrollbar>
  </div>
}